import { gql } from '../__generated__';

const HistoricalModelItem = gql(`
  fragment HistoricalGuidePriceModelItem on HistoricalGuidePriceModel {
    id
    price
    pendingPriceChange {
      id
      timeOfChange
      newPrice
    }
  }
`);

export let GET_HISTORICAL_PRICE = gql(`
  query GetHistoricalPrice {
    historical: getHistoricalGuidePrice {
      ...HistoricalGuidePriceModelItem
    }
  }
`);

export const UPDATE_HISTORICAL_PRICE = gql(`
  mutation ChangeHistoricalGuidePrice($input: ChangeHistoricalGuidePriceInput!) {
    changeHistoricalGuidePrice(input: $input) {
      ...HistoricalGuidePriceModelItem
    }
  }
`);

export const CANCEL_HISTORICAL_PRICE_UPDATE = gql(`
  mutation CancelHistoricalPriceChange {
    cancelHistoricalPriceChange {
      ...HistoricalGuidePriceModelItem
    }
  }
`);